const getters = {
  listAll: state => {
    return state.requests_list
  }
}
export default getters



//////////////////
// WEBPACK FOOTER
// ./state/request/request.getters.js
// module id = null
// module chunks = 